import "./metanavigation.scss";
import "./metanavigation-mobile.scss";

import SelfInitComponent from "General/global-js/SelfInitComponent";
import { metaNavLeftSlidingMenu } from "./metanavleft-slidingMenu";
import { SlidingMenuPlugin } from "General/global-js/SlidingMenuPlugin";

class MetaNavigationLeftComponent extends SelfInitComponent {
  constructor(selector) {

    super(selector);
  }

  init() {
    SlidingMenuPlugin();
    metaNavLeftSlidingMenu();
  }
}
new MetaNavigationLeftComponent("#headerMetaNavigationLeft");
